import { render, staticRenderFns } from "./SsModal.vue?vue&type=template&id=2d187812&"
import script from "./SsModal.vue?vue&type=script&lang=js&"
export * from "./SsModal.vue?vue&type=script&lang=js&"
import style0 from "./SsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports